import { render, staticRenderFns } from "./SelfAssessmentDetail.vue?vue&type=template&id=09c0c8c9&scoped=true&"
import script from "./SelfAssessmentDetail.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentDetail.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/self-assessment-detail.scss?vue&type=style&index=0&id=09c0c8c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0c8c9",
  null
  
)

export default component.exports